import { useNavigate } from "react-router-dom";
import { HiOutlineArrowNarrowLeft } from "react-icons/hi";
const BackButton = () => {
  const navigate = useNavigate();

  return (
    <div
      className="back-button"
      onClick={() => navigate(-1)} // Go back to the previous page
    >
      <HiOutlineArrowNarrowLeft />
    </div>
  );
};

export default BackButton;
